// if (typeof(tio) == "undefined") {
//   tio = {};
// }
import { objAny } from "@/common/common-interface";
import config from "@/config/config";
import common from "@/common/common";
import store from "@/store/index";

// const tioConfig: objAny = {
//   ip: "",
//   domain: ""
// };

const tio: objAny = {};
tio.ws = {};

/**

 * @param {*} paramStr 加在ws url后面的请求参数，形如：name=张三&id=12
 * @param {*} handler 
 * @param {*} heartbeatTimeout 心跳时间 单位：毫秒
 * @param {*} reconnInterval 重连间隔时间 单位：毫秒
 * @param {*} binaryType 'blob' or 'arraybuffer';//arraybuffer是字节
 */
tio.ws = function(param: objAny = {}) {
  // this.ip = config.tioConfig.ip;
  const host = window.location.host;
  // this.port = config.tioConfig.port;
  // this.url = config.tioConfig.ws_protocol + "://" + this.ip + ":" + this.port;
  this.url = config.tioConfig.ws_protocol + "://" + host + "/websocket";
  this.binaryType = config.tioConfig.binaryType || "arraybuffer";
  this.heartbeatTimeout = config.tioConfig.heartbeatTimeout;
  this.reconnInterval = config.tioConfig.reconnInterval;
  this.index = 0;
  if (this.pingIntervalId) {
    clearInterval(this.pingIntervalId); // clear send heartbeat task
  }

  const state: any = store.state; // eslint-disable-line
  const token = state.sys.userInfo.accessToken;
  if (param.data) {
    this.url += "?token=" + token + common.parseParam(param.data);
    this.reconnUrl = this.url + "&";
  } else {
    this.reconnUrl = this.url + "?token=" + token + "&";
  }
  this.reconnUrl += "tiows_reconnect=true";
  // this.param = param

  this.handler = param;

  this.lastInteractionTime = function() {
    if (arguments.length == 1) {
      this.lastInteractionTimeValue = arguments[0];
    }
    return this.lastInteractionTimeValue;
  };

  this.heartbeatSendInterval = this.heartbeatTimeout / 2;

  this.connect = function(isReconnect: boolean) {
    let _url = this.url;
    if (isReconnect) {
      _url = this.reconnUrl;
    }
    console.log(_url);
    const ws: objAny = new WebSocket(_url);
    this.ws = ws;

    ws.binaryType = this.binaryType; // 'arraybuffer'; // 'blob' or 'arraybuffer';//arraybuffer是字节
    const self = this;
    ws.onopen = function(event: objAny) {
      self.handler.onopen.call(self.handler, event, ws);
      self.lastInteractionTime(new Date().getTime());

      // if (self.index < 3) {
      self.pingIntervalId = setInterval(function() {
        // self.index = self.index + 1;
        self.ping(self);
      }, self.heartbeatSendInterval);
      // }
    };
    ws.onmessage = function(event: objAny) {
      self.handler.onmessage.call(self.handler, event, ws);
      self.lastInteractionTime(new Date().getTime());
    };
    ws.onclose = function(event: objAny) {
      clearInterval(self.pingIntervalId); // clear send heartbeat task

      if (self.index < 3) {
        self.index = self.index + 1;
        self.reconn(event);
      } else {
        try {
          self.handler.onclose.call(self.handler, event, ws);
        } catch (error) {}
      }
    };
    ws.onerror = function(event: objAny) {
      self.handler.onerror.call(self.handler, event, ws);
    };

    return ws;
  };

  this.reconn = function(event: Event) {
    const self = this;
    setTimeout(function() {
      const ws = self.connect(true);
      self.ws = ws;
    }, self.reconnInterval);
  };

  this.ping = function() {
    const iv = new Date().getTime() - this.lastInteractionTime(); // 已经多久没发消息了
    // 单位：秒
    if (this.heartbeatSendInterval + iv >= this.heartbeatTimeout) {
      this.handler.ping(this.ws);
    }
  };

  this.send = function(data: string) {
    this.ws.send(data);
  };
  this.close = function() {
    this.ws.close();
  };
};

export default tio;
